import { Injectable } from '@angular/core';
import type { PalantirDialogRef } from '../dialog/dialog-ref.service';
import { PalantirDialogService } from '../dialog/dialog.service';
import { selectItemDialogLogger } from './logger.instance';
import { PalantirSelectItemDialogComponent } from './select-item-dialog.component';
import type { PalantirSelectItemDialogOptions } from './select-item-dialog.type';

const logger = selectItemDialogLogger.extend('service');

@Injectable({
  providedIn: 'root',
})
export class PalantirSelectItemDialogService {
  public constructor(private readonly palantirDialogService: PalantirDialogService) {}

  public openDialog<T>(params?: PalantirSelectItemDialogOptions<T>): PalantirDialogRef {
    logger.info('Opening select item dialog', { type: params?.type });

    return this.palantirDialogService.openDialog(PalantirSelectItemDialogComponent, {
      size: 'medium',
      data: {
        ...params,
        type: params?.type ?? 'multiple',
      },
      fullHeight: true,
    });
  }
}
